import React, { useEffect, useRef, useState } from "react";
import './SettingsPanel.css';
import InputBox from "../../components/reusable/InputBox";
import { generateUUID } from "../../utilities/js/UUIDGenerator";
import { isClickInBox } from "../../utilities/js/ClickPositionHelper";
import { unfreezeBody } from "utilities/js/styling/domUtilities";
import { isValidContestantInput } from "utilities/js/callouts/Sanitizer";
import ScrollHelper from "components/reusable/ScrollHelper";
import { deleteBracket } from "utilities/js/callouts/CalloutFactory";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";


const SettingsPanel = (props) => {
    
    const contentRef = useRef(null);
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    let defaultRawContestants = '';
    if (props.contestantMap) {
        Object.keys(props.contestantMap).forEach(contestantId => {
            defaultRawContestants += props.contestantMap[contestantId].name + '\n';
        })
    }
    let defaultTourneyName = props.tourneyName ? props.tourneyName : 'Tourney Name';

    const [rawContestantNames, setRawContestantNames] = useState(defaultRawContestants);
    const [contestantMap, setContestantMap] = useState({});
    const [contestantCount, setContestantCount] = useState(0);
    const [randomSeeding, setRandomSeeding] = useState(props.randomSeeding ? props.randomSeeding : false);
    const [allowDelete, setAllowDelete] = useState(false);
    const [disableDelete, setDisableDelete] = useState(true);

    useEffect(() => {
        document.addEventListener('mousedown', closePanelOnOutsideClick);
    }, [])


    function closePanelOnOutsideClick(event) {
        let panel = document.querySelector('#settingsPanel');
        if (panel) {
            if (!isClickInBox(event.x, event.y, panel.getBoundingClientRect())) {
                closePanel(event);
            }
        }
    }


    function setRawContestants(event) {
        let input = event.target.value;
        // if(input.match(new RegExp("\n", "g")).length >= 10){
        //     input = input.split("\n").slice(0,10).join("\n");
        // }

        //TODO: Consider changing method of contestant input to separate input boxes with controls that allow seed changes, deletes, etc

        setRawContestantNames(input);
        organizeContestants(input, randomSeeding);
    }

    function organizeContestants(rawContestantNames, isRandom) {

        let currentContestants = rawContestantNames.split("\n");
        if (isRandom) {
            currentContestants = shuffle([...currentContestants]);
        }

        let updatedContestantMap = {};
        let updatedContestantCount = 0;
        currentContestants.forEach((contestant) => {
            if (contestant !== '') {
                updatedContestantCount++;
                let id = generateUUID();
                updatedContestantMap[id] = { name: contestant, seed: updatedContestantCount, id: id };
            }
        });

        setContestantMap(updatedContestantMap);
        setContestantCount(updatedContestantCount);

        if(updatedContestantCount > 1){
            props.updateSetting('contestantMap', updatedContestantMap);
        }
    }

    function updateAllowDelete(event, newValue){
        let disableDelete = true;
        if(event.currentTarget.checked){
            disableDelete = false;
        }
        setDisableDelete(disableDelete)
        setAllowDelete(newValue);
    }

    function updateRandomSeeding(event) {
        let isRandomSeeding = event.target.checked;
        setRandomSeeding(isRandomSeeding)
        organizeContestants(rawContestantNames, isRandomSeeding);
    }
    function closePanel(event){
        // if(this.isTourneyNameValid(this.props.defaults.tourneyName) && isValidContestantInput(rawContestantNames)){
            props.closePanel(event);
        // }
    }

    function updateSetting(event, newValue){
        if(event.currentTarget.dataset.name === 'tourneyName'){
            if(isTourneyNameValid(newValue)){
                props.updateSetting(event.currentTarget.dataset.name, newValue);
            }
        }else{        
            props.updateSetting(event.currentTarget.dataset.name, newValue);
        }
    }

    function clearContestants(event) {
        setRawContestantNames('');
        // props.updateSetting('contestantMap', {});
        // props.clearContestants();
    }

    function isTourneyNameValid(value){
        if(value.length < 2){
            return false;
        }
        return true;
    }

    function shuffle(a) {
        var j, x, i;
        for (i = a.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = a[i];
            a[i] = a[j];
            a[j] = x;
        }
        return a;
    }
    async function callDeleteBracket(){
        try{
            setDisableDelete(true);
            await deleteBracket({bracketId: props.bracketId});    
            queryClient.invalidateQueries({ queryKey: ['brackets'] })
            navigateToLandingPage({routerNav: navigate});
        }catch(error){
            console.log(error);
            setDisableDelete(null);
        }
    }

    function getDeletionSection(){
        if(props.bracketId){
            return (
                <div className="settings-section">
                    <div className="section-label-text">Delete Bracket</div>                                 

                    <div className="checkbox-container">
                        <div className="label-text">Allow Deletion</div>
                        <InputBox id="allowDelete" type="checkbox" name="allowDelete" value={allowDelete} valueChangedCallback={updateAllowDelete}></InputBox>
                    </div>
                    <div className="delete-button-container">
                        <button className='nav-button-red' onClick={callDeleteBracket} disabled={disableDelete}>Delete</button>
                    </div>
                </div>
            )
        }
    }

    
    return (
        <div id="settingsPanel" className="side-panel">

            <div className="popup-panel-header">
                <div className="popup-panel-heading">Bracket Settings</div>
                <div className="popup-header-spacer"><button className='nav-button' onClick={closePanel}>Done</button></div>
                
            </div>

            <div className="side-panel-contents no-padding" ref={contentRef}>

                <div className="settings-section">
                    <div className="tourney-name-input-container">
                        <div className="section-label-text">Tourney Name</div>
                        <InputBox id="tourneyName" class="tourney-name-input" name="tourneyName" placeholder="Input a bracket name (min. 2 characters)" warningMessage="Tourney Name is required" value={props.defaults.tourneyName} valueChangedCallback={updateSetting} validChecker={isTourneyNameValid}></InputBox>
                    </div>
                </div>

                <div className="settings-section">
                    <div className="contestant-input-container">
                        <div className="section-label-text">Add Contestants</div>
                        <InputBox id="addContestants" type="textarea" placeholder="Input up to 64 contestants separated by spaces" value={rawContestantNames} class="contestant-input"  name="contestants" warningMessage="You can only publish between 2 and 64 contestants" rows="8" valueChangedCallback={setRawContestants} validChecker={isValidContestantInput}></InputBox>
                    </div>

                    <div class="clear-contestants-button-container">
                        <button className='clear-contestants-button' onClick={clearContestants}>Clear Contestants</button>
                    </div>
                </div>


                <div className="settings-section">
                    <div className="section-label-text">Bracket Settings</div>

                    <div className="checkbox-container">
                        <div className="label-text">Double Elimination Tournament</div>
                        <InputBox id="doubleElim" type="checkbox"  name="isDoubleElim" value={props.defaults.isDoubleElim} valueChangedCallback={updateSetting}></InputBox>
                    </div>


                    <div className="checkbox-container">
                        <div className="label-text">Hide Byes</div>
                        <InputBox id="hideByes" type="checkbox" name="hideByes" value={props.defaults.hideByes} valueChangedCallback={updateSetting}></InputBox>
                    </div>                        
                    
                    <div className="checkbox-container">
                        <div className="label-text">Round Spacing</div>
                        <InputBox id="roundSpacing" type="checkbox" name="roundSpacing" value={props.defaults.roundSpacing} valueChangedCallback={updateSetting}></InputBox>
                    </div>

                    <div className="checkbox-container">
                        <div className="label-text">Random Seeding</div>
                        <InputBox id="randomSeeding" type="checkbox" name="randomSeeding" value={props.randomSeeding} valueChangedCallback={updateRandomSeeding}></InputBox>
                    </div>

                </div>
                {getDeletionSection()}
                
                <ScrollHelper float="true"></ScrollHelper>
            </div>


            {/* <div class="panel-footer">
                <button className='nav-button' onClick={this.props.closePanel}>Done</button>
            </div> */}
        </div>
    );
    
}

export default SettingsPanel;

// class SettingsPanel extends React.Component {

//     constructor(props) {
//         super(props);

//         let defaultRawContestants = '';
//         if (this.props.contestantMap) {
//             Object.keys(this.props.contestantMap).forEach(contestantId => {
//                 defaultRawContestants += this.props.contestantMap[contestantId].name + '\n';
//             })
//         }
//         let defaultTourneyName = this.props.tourneyName ? this.props.tourneyName : '';

//         this.state = {
//             displayPanel: false,
//             rawContestantNames: defaultRawContestants,
//             contestantMap: {},
//             contestantCount: 0,
//             randomSeeding: this.props.randomSeeding ? this.props.randomSeeding : false,
//             tourneyName: defaultTourneyName,
//             allowDelete: false,
//             disableDelete: true
//         };

//         // this.setDoubleElim = this.setDoubleElim.bind(this);
//         // this.setHideByes = this.setHideByes.bind(this);
//         this.setRandomSeeding = this.setRandomSeeding.bind(this);
//         this.setRawContestants = this.setRawContestants.bind(this);
//         this.organizeContestants = this.organizeContestants.bind(this);
//         this.closePanelOnOutsideClick = this.closePanelOnOutsideClick.bind(this);
//         // this.setTourneyName = this.setTourneyName.bind(this);
//         this.clearContestants = this.clearContestants.bind(this);
//         this.updateSetting = this.updateSetting.bind(this);
//         this.setAllowDelete = this.setAllowDelete.bind(this)
//         this.deleteBracket = this.deleteBracket.bind(this);
//         this.closePanel = this.closePanel.bind(this);

//         this.contentRef = React.createRef();
//     }

//     componentDidMount() {
//         document.addEventListener('mousedown', this.closePanelOnOutsideClick);
//     }

//     closePanelOnOutsideClick(event) {
//         let panel = document.querySelector('#settingsPanel');
//         if (panel) {
//             if (!isClickInBox(event.x, event.y, panel.getBoundingClientRect())) {
//                 this.closePanel(event);
//             }
//         }
//     }


//     setRawContestants(event) {
//         let input = event.target.value;
//         // if(input.match(new RegExp("\n", "g")).length >= 10){
//         //     input = input.split("\n").slice(0,10).join("\n");
//         // }

//         //TODO: Consider changing method of contestant input to separate input boxes with controls that allow seed changes, deletes, etc

//         this.setState({ rawContestantNames: input });
//         this.organizeContestants(input, this.state.randomSeeding);
//     }

//     organizeContestants(rawContestantNames, isRandom) {

//         let currentContestants = rawContestantNames.split("\n");
//         if (isRandom) {
//             currentContestants = this.shuffle([...currentContestants]);
//         }

//         let contestantMap = {};
//         let contestantCount = 0;
//         currentContestants.forEach((contestant) => {
//             if (contestant !== '') {
//                 contestantCount++;
//                 let id = generateUUID();
//                 contestantMap[id] = { name: contestant, seed: contestantCount, id: id };
//             }
//         });

//         this.setState({
//             contestantMap: contestantMap,
//             contestantCount: contestantCount
//         });

//         if(contestantCount > 1){
//             this.props.updateSetting('contestantMap', contestantMap);
//         }
//     }

//     setAllowDelete(event, newValue){
//         let disableDelete = true;
//         if(event.currentTarget.checked){
//             disableDelete = false;
//         }
//         this.setState({
//             disableDelete: disableDelete,
//             allowDelete: newValue
//         })
//     }

//     setRandomSeeding(event) {
//         let isRandomSeeding = event.target.checked;
//         this.setState({ randomSeeding: isRandomSeeding })
//         this.organizeContestants(this.state.rawContestantNames, isRandomSeeding);
//     }
//     closePanel(event){
//         // if(this.isTourneyNameValid(this.props.defaults.tourneyName) && isValidContestantInput(this.state.rawContestantNames)){
//             this.props.closePanel(event);
//         // }
//     }

//     updateSetting(event, newValue){
//         if(event.currentTarget.dataset.name === 'tourneyName'){
//             if(this.isTourneyNameValid(newValue)){
//                 this.props.updateSetting(event.currentTarget.dataset.name, newValue);
//             }
//         }else{        
//             this.props.updateSetting(event.currentTarget.dataset.name, newValue);
//         }
//     }

//     clearContestants(event) {
//         this.setState({ rawContestantNames: '' });
//         // this.props.updateSetting('contestantMap', {});
//         // this.props.clearContestants();
//     }

//     isTourneyNameValid(value){
//         if(value.length < 2){
//             return false;
//         }
//         return true;
//     }

//     shuffle(a) {
//         var j, x, i;
//         for (i = a.length - 1; i > 0; i--) {
//             j = Math.floor(Math.random() * (i + 1));
//             x = a[i];
//             a[i] = a[j];
//             a[j] = x;
//         }
//         return a;
//     }
//     async deleteBracket(){
//         try{
//             this.setState({disableDelete: true})
//             await deleteBracket({bracketId: this.props.bracketId});
//             navigateToLandingPage({routerNav: this.props.navigate})
//         }catch(error){
//             console.log(error);
//             this.setState({disableDelete: null})
//         }
//     }
//     get contentReference(){
//         return this.contentRef;
//     }

//     get deletionSection(){
//         if(this.props.bracketId){
//             return (
//                 <div className="settings-section">
//                     <div className="section-label-text">Delete Bracket</div>                                 

//                     <div className="checkbox-container">
//                         <div className="label-text">Allow Deletion</div>
//                         <InputBox id="allowDelete" type="checkbox" name="allowDelete" value={this.state.allowDelete} valueChangedCallback={this.setAllowDelete}></InputBox>
//                     </div>
//                     <button className='nav-button-red' onClick={this.deleteBracket} disabled={this.state.disableDelete}>Delete</button>
//                 </div>
//             )
//         }
//     }
//     render() {

//         return (
//             <div id="settingsPanel" className="side-panel">

//                 <div className="popup-panel-header">
//                     <div className="popup-panel-heading">Bracket Settings</div>
//                     <div className="popup-header-spacer"><button className='nav-button' onClick={this.closePanel}>Done</button></div>
                    
//                 </div>

//                 <div className="side-panel-contents no-padding" ref={this.contentRef}>

//                     <div className="settings-section">
//                         <div className="tourney-name-input-container">
//                             <div className="section-label-text">Tourney Name</div>
//                             <InputBox id="tourneyName" class="tourney-name-input" name="tourneyName" placeholder="Input a bracket name (min. 2 characters)" warningMessage="Tourney Name is required" value={this.props.defaults.tourneyName} valueChangedCallback={this.updateSetting} validChecker={this.isTourneyNameValid}></InputBox>
//                         </div>
//                     </div>

//                     <div className="settings-section">
//                         <div className="contestant-input-container">
//                             <div className="section-label-text">Add Contestants</div>
//                             <InputBox id="addContestants" type="textarea" placeholder="Input up to 64 contestants separated by spaces" value={this.state.rawContestantNames} class="contestant-input"  name="contestants" warningMessage="You can only publish between 2 and 64 contestants" rows="8" valueChangedCallback={this.setRawContestants} validChecker={isValidContestantInput}></InputBox>
//                         </div>

//                         <div class="clear-contestants-button-container">
//                             <button className='clear-contestants-button' onClick={this.clearContestants}>Clear Contestants</button>
//                         </div>
//                     </div>


//                     <div className="settings-section">
//                         <div className="section-label-text">Bracket Settings</div>

//                         <div className="checkbox-container">
//                             <div className="label-text">Double Elimination Tournament</div>
//                             <InputBox id="doubleElim" type="checkbox"  name="isDoubleElim" value={this.props.defaults.isDoubleElim} valueChangedCallback={this.updateSetting}></InputBox>
//                         </div>


//                         <div className="checkbox-container">
//                             <div className="label-text">Hide Byes</div>
//                             <InputBox id="hideByes" type="checkbox" name="hideByes" value={this.props.defaults.hideByes} valueChangedCallback={this.updateSetting}></InputBox>
//                         </div>                        
                        
//                         <div className="checkbox-container">
//                             <div className="label-text">Round Spacing</div>
//                             <InputBox id="roundSpacing" type="checkbox" name="roundSpacing" value={this.props.defaults.roundSpacing} valueChangedCallback={this.updateSetting}></InputBox>
//                         </div>

//                         <div className="checkbox-container">
//                             <div className="label-text">Random Seeding</div>
//                             <InputBox id="randomSeeding" type="checkbox" name="randomSeeding" value={this.props.randomSeeding} valueChangedCallback={this.setRandomSeeding}></InputBox>
//                         </div>

//                     </div>
//                     {this.deletionSection}
                    
//                     <ScrollHelper float="true"></ScrollHelper>
//                 </div>


//                 {/* <div class="panel-footer">
//                     <button className='nav-button' onClick={this.props.closePanel}>Done</button>
//                 </div> */}
//             </div>
//         );
//     }
// }

// export default NavigatorWrapper(SettingsPanel);
